<template>
	<div class="modal fade" id="modal-email">
		<div class="modal-dialog modal-lg">
			<div class="modal-content">
				
				<div class="modal-header">
					<h4 class="modal-title">Email</h4>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>

				<div class="modal-body">

					<div class="row">
						<div class="col-md-12">
							<img :src="logotipo" style="width: 16%; margin-left: 42%;">
						</div>
					</div>

					<div class="row">
						<div class="col-md-2">
				            <div class="form-group">
				                <label>ID</label>
				                <input type="text" class="form-control form-control-sm" :value="email.id" readonly>
				            </div>
				        </div>

				        <div class="col-md-5">
				            <div class="form-group">
				                <label>Assunto</label>
				                <input type="text" class="form-control form-control-sm" :value="email.assunto" readonly>
				            </div>
				        </div>

				        <div class="col-md-5">
				            <div class="form-group">
				                <label>Origem</label>
				                <input type="text" class="form-control form-control-sm" :value="email.origem" readonly>
				            </div>
				        </div>
					</div>

					<div class="row">
						<div class="col-md-4">
				            <div class="form-group">
				                <label>Data</label>
				                <input type="text" class="form-control form-control-sm" :value="DateFormat(email.created_at)" readonly>
				            </div>
				        </div>

				        <div class="col-md-4">
				            <div class="form-group">
				                <label>Hora</label>
				                <input type="text" class="form-control form-control-sm" :value="convert_hor(email.created_at)" readonly>
				            </div>
				        </div>

						<div class="col-md-4">
				            <div class="form-group">
				                <label>Destino</label>
				                <input type="text" class="form-control form-control-sm" :value="email.destino" readonly>
				            </div>
				        </div>
					</div>

					<div class="row">
						<div class="col-md-12">
				            <div class="form-group">
				                <label>Com conhecimento</label>
				                <input type="text" class="form-control form-control-sm" :value="email.mailcc" readonly>
				            </div>
				        </div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import replace from "@/mixins/replace.js"

	export default {
		name: "modal-email",
		props: [ 'email' ],
		mixins: [replace],

		data: () => { 
			return {
				incomplete: false,
			}
		},

		computed: {
			logotipo() { 
				return this.$store.state.config.logotipo;
			}
		},

		methods: {
			convert_hor(payload){
				var nova_hora = new Date(payload);
				nova_hora.setHours(nova_hora.getHours()-3);
				return nova_hora.getHours() + ':' + nova_hora.getMinutes() + ':' + nova_hora.getSeconds();
			},
		}
	}
</script>

<style scoped>
</style>